import domain from './conf.js'

const api = {
  conf: domain + 'cfg',
  job: domain + 'job/',
  files: domain + 'doutor/arquivo',
  files_supporter: domain + 'agregado_doutor/arquivo',
  rate: domain + 'avaliacao',
  vote: domain + 'pesquisa_logada',
  opencep: 'https://opencep.com/v1/?',
  cep: 'https://viacep.com.br/ws/?/json/',
  bank: domain + 'banco/lista',
  type_service: domain + 'tipo_servico/distinto',
  attendance: domain + 'job/acompanhamento_atendimento',
  pass: domain + 'usuario/senha',
  disable_pendency: domain + 'doutor/desativacao/pendencia',
  motivo: 'https://docs.google.com/forms/d/1UPk2Ji9dK6mNn-Z1ISA_6V0GpZv6EbTmHux4po3FPRw/viewform?edit_requested=true',
  report: 'https://nscommunity.netsupport.com.br/t/sugestoes-e-problemas-plataforma/1820',
  resetPass: domain + 'usuario/reseta_senha',
  cities: {
    brasil: domain + 'cidade_brasil/lista'
  },
  comm: {
    getList: domain + 'comunicado_usuario/lista',
    get: domain + 'comunicado_usuario/',

  },
  login: {
    auth: domain + 'sessao',
    whitelabel: domain + '?/sessao',
    session: domain + 'sessao/minha',
    forgot: domain + 'usuario/email_reseta_senha/',
    newAccount: '/supporter/novo',
  },
  orientation_default: {
    get: domain + 'orientacao_padrao/',
  },
  supporter: {
    material: domain + 'material/job/',
    dados_nf: domain + 'nota_fiscal/dados_emissao/doutor/',
    chavePix: domain + 'doutor/chave_pix',
    clicksign: {
      contrato: domain + 'contrato_digital/pendencia/operacao/',
      minuta: domain + 'contrato_doutor/minuta/',
      download: domain + 'contrato_doutor/contrato_assinado/',
      expirado: domain + 'contrato_doutor/?/liberacao_expirado/operacao/',
      excecao: domain + 'contrato_doutor/?/liberacao_excecao/operacao/',
      assinado: domain + 'contrato_digital/assinado/operacao/' // GET
    },
    docs: domain + 'doutor/documentos',
    enable: domain + 'doutor/disponibilidade',
    nf: domain + 'nota_fiscal/doutor/arquivo/',
    telegram: domain + 'doutor/autoriza_notificacao',
    dashboard: {
      jobs: domain + 'job/novo_lista',
    },
    orientation: {
      get: domain + 'orientacao/',
      set: domain + 'job/?/evento/orienta_doutor'
    },
    deslocation: domain + 'job/?/evento/inicio_deslocamento',
    checkin: domain + 'job/?/evento/checkin',
    note: {
      set: domain + 'job/?/nota',
      escopo: domain + 'job/?/complemento_escopo/lista'
    },
    aggregate: domain + 'job/?/evento/associa_agregado_doutor',
    remove_aggregate: domain + 'job/?/evento/remove_agregado_doutor',
    doctor: domain + 'job/1/evento/associa_doutor',
    attach: domain + 'job/?/arquivo',
    finish: domain + 'job/?/evento/encerra_job',
    attendance: domain + 'job/?/atendimento',
    pendency: domain + 'pendencia_doutor/lista',
    pendencies: domain + 'pendencia_doutor/lista/status',
    pendencies_aggregate: domain + 'pendencia_agregado_doutor/lista/status',
    pendency_aggregate: domain + 'pendencia_agregado_doutor/lista',
    term: domain + 'doutor/termo',
    term_supporter: domain + 'agregado_doutor/termo',
    rules: domain + 'doutor/regras',
    rules_supporter: domain + 'agregado_doutor/regras',
    competence: domain + 'doutor/competencia',
    slack: {
      invite: 'https://join.slack.com/t/doutoresemtecnologia/shared_invite/zt-cmmhu14x-y4xTbXketkPIye8Fcij9Fg',
      sync: domain + 'doutor/slack'
    },
    perfil: domain + 'doutor/perfil',
    documentos: domain + 'doutor/documentos',
    dados_bancarios: domain + 'doutor/dados_bancarios',
    perfil_aggregate: domain + 'agregado_doutor/dados_pessoais',
    new: domain + 'candidato_doutor',
    candidates: {
      list: domain + 'candidato_doutor/lista',
      del: domain + 'candidato_doutor/'
    },
    token: domain + 'candidato_doutor/token/',
    disable: domain + 'doutor/desativa',
    apply: domain + 'doutor/candidato_job/lista',
    available: domain + 'doutor/job/divulgado',
    candidate: domain + 'doutor/get_job_candidato/',
    setcandidate: domain + 'doutor/candidato_job/',
    video: domain + 'doutor/altera_status_video',
    discourse: domain + 'usuario/discourse/',
    cancelCandidate: domain + 'doutor/candidato_job/',
    extract: domain + 'relatorio/financeiro/extrato/doutor',
    stats: domain + 'doutor/estatisticas',
    stats_aggregate: domain + 'agregado_doutor/estatisticas',
    tipo_ferramenta: {
      list: domain + 'tipo_ferramenta/lista',
      get: domain + 'tipo_ferramenta/?',
      post: domain + 'tipo_ferramenta',
      delete: domain + 'tipo_ferramenta/?',
      put: domain + 'tipo_ferramenta/?'
    },
    ferramenta: {
      list: domain + 'ferramenta/lista',
      get: domain + 'ferramenta/?',
      post: domain + 'ferramenta',
      delete: domain + 'ferramenta/?',
      put: domain + 'ferramenta/?'
    }

  },
  client: {
    perfil: domain + 'cliente/meu',
    client_client: domain + 'cliente_cliente/lista',
    client_call: domain + 'cliente/?/codigo_chamado_cliente/',
    get: domain + 'cliente/',
    servicestype: {
      url: domain + 'tipo_servico/lista/cliente',
      type: 'post'
    },
    diary: {
      url: domain + 'job/agenda_alocacao/',
      type: 'get'
    },
    job: {
      avulso: {
        url: domain + 'job/avulso',
        type: 'post'
      },
      alocacao: {
        url: domain + 'job/alocacao',
        type: 'post'
      }
    }
  },
  admin: {
    vtal: {
      novo: { url: domain + 'vtexp_doutor', type: 'post' },
      lista: { url: domain + 'vtexp_doutor/lista', type: 'post' },
      editar: { url: domain + 'vtexp_doutor/', type: 'put' },
      desativa: domain + 'vtexp_doutor/desativa/',
      ativa: domain + 'vtexp_doutor/ativa/',
      excluir: domain + 'vtexp_doutor/',
      vincula: { url: domain + 'vtexp_doutor/vincula', type: 'put'},
      vinculaExcecao: { url: domain + 'vtexp_doutor/vincula_excecao', type: 'put'},
      desvincula: { url: domain + 'vtexp_doutor/desvincula', type: 'put'},
      excecoes: domain + 'vtexp_doutor/?/excecoes',

    },
    // Pendências de técnico V.texp (sc-9881): matrículas que travam job, sugestão e cadastro com vínculo.
    vtexpPendencia: {
      pendencias: domain + 'vtexp_doutor/pendencias',
      sugestao: domain + 'vtexp_doutor/matricula/?/sugestao',
      cadastraVincula: { url: domain + 'vtexp_doutor/cadastra_vincula/', type: 'post' },
    },
    praca: {
      pendencias: domain + 'cidade_vtal/pendencias',
      tipos: domain + 'cidade_vtal/tipos_servico',
      sugestoes: domain + 'cidade_vtal/cidade/?/cep/sugestoes',
      busca: domain + 'cidade_vtal/cidade/?/cep/busca',
      confere: domain + 'cidade_vtal/cidade/?/cep/?',
      lista: { url: domain + 'cidade_vtal/lista', type: 'post' },
      nova: { url: domain + 'cidade_vtal/', type: 'post' },
      editar: { url: domain + 'cidade_vtal/', type: 'put' },
      excluir: domain + 'cidade_vtal/',
      get: domain + 'cidade_vtal/',
    },
    // Cliente do cliente (sc-9885): cadastro por cliente e vínculo na categorização.
    // `novo` é sem barra final: a rota do backend é `POST /cliente_cliente`.
    // `status` ativa ou desativa pelo corpo {status: 'ativo' | 'inativo'} (sc-9886 do backend).
    clienteCliente: {
      lista: { url: domain + 'cliente_cliente/lista', type: 'post' },
      novo: { url: domain + 'cliente_cliente', type: 'post' },
      editar: domain + 'cliente_cliente/',          // PUT    cliente_cliente/<id>
      status: domain + 'cliente_cliente/?/status',  // PUT    com {status}
      excluir: domain + 'cliente_cliente/',         // DELETE cliente_cliente/<id>
      get: domain + 'cliente_cliente/',             // GET    cliente_cliente/<id>
    },
    material: {
      novo: { url: domain + 'material', type: 'post' },
      get: { url: domain + 'material/', type: 'get' },
      sku: { url: domain + 'material/sku/', type: 'get' },
      list: { url: domain + 'material/lista', type: 'post' },
      update: { url: domain + 'material', type: 'put' },
      del: { url: domain + 'material/', type: 'del' },
      ativa: domain + 'material/ativa/',
      desativa: domain + 'material/desativa/',
      serviceType: domain + 'material/tipo_servico/',
    },
    nuh: {
      get: domain + 'tipo_servico/nuh',
      post: domain + 'tipo_servico/nuh'
    },
    contratos: {
      url: domain + 'contrato_digital',
      list: domain + 'contrato_digital/lista', // POST
      dlist: domain + 'contrato_digital/lista/doutor/', // POST
      pendencia: domain + 'contrato_digital/?/pendencia_doutor', // POST
      pendenciadel: domain + 'contrato_digital/?/pendencia_doutor/doutor/', // DEL
      minuta: domain + 'contrato_digital/pendencia/',
      ativa: domain + 'contrato_digital/?/ativa', //PUT
      desativa: domain + 'contrato_digital/?/desativa', //PUT
      assinado: domain + 'contrato_digital/assinado/operacao/?/doutor/'  // GET        
    },
    imports: {
      toa: domain + 'toa/arquivo/processa'
    },
    km: {
      add: domain + "job/?/km",
      limit: domain + 'job/?/limite_lancamento_km'
    },
    funcionario: {
      novo: {
        url: domain + 'funcionario',
        type: 'post'
      },
      update: {
        url: domain + 'funcionario/',
        type: 'put'
      },
      get: {
        url: domain + 'funcionario/',
        type: 'get'
      },
      list: {
        url: domain + 'funcionario/lista',
        type: 'post'
      },
      del: {
        url: domain + 'funcionario/',
        type: 'delete'
      },
      status: {
        url: domain + 'funcionario/?/status',
        type: 'put'
      }
    },
    jobs: {
      detalhaFechamento: domain + 'job/?/fecha/atendimento',
      rescindirAloc: domain + 'job/?/evento/rescinde_alocacao',
      remove_doutor: domain + 'job/?/evento/remove_doutor',
      divulga: domain + 'job/?/evento/divulga_job',
      descartar: domain + 'job/?/descarta_candidato_job/',
      selecionaCandidato: domain + 'job/?/seleciona_candidato_job/',
      candidatos: domain + 'job/?/candidato_job',
      agenda: domain + 'job/?/agendamento',
      agenda_cancela: domain + 'job/?/evento/cancela_agendamento',
      cancela_fechamento: domain + 'job/?/cancela_fechamento',
      improdutivo: domain + 'job/?/evento/improdutivo',
      reagendar: domain + 'job/?/evento/reagenda',
      cancel: domain + "job/?/evento/cancela_job",
      costLimit: domain + "job/?/limite_lancamento_custo",
      lancamento: domain + "job/?/lancamento",
      desconto_tempo: domain + "job/?/lancamento_desconto_tempo",
      hora_extra: domain + "job/?/lancamento_hora_extra",
      estornar: domain + "/job/?/lancamento/",
      assoc: domain + 'job/acompanhamento_associacao',
      get: {
        url: domain + 'job/',
        type: 'get'
      },
      list:
      {
        url: domain + 'job/novo_lista',
        type: 'post'
      },
      create: {
        url: domain + 'job',
        type: 'post'
      },
      categorize: domain + 'job/?/evento/categorizacao',
      faturamento: domain + 'job/?/evento/faturamento',
      changeGD: domain + 'job/?/gestor/',
      validate: domain + 'job/?/evento/valida',
      invalidate: domain + 'job/?/evento/invalida',
      historic: domain + 'job/?/historico',
      fecha: domain + 'job/?/fecha',
      finalizacao: domain + 'job/?/evento/finaliza_job',
    },
    supporter: {
      get: {
        type: 'get',
        url: domain + 'doutor/'
      },
      list: {
        type: 'post',
        url: domain + 'doutor/lista'
      },
      create: {
        type: 'post',
        url: domain + 'doutor'
      },
      update: {
        type: 'put',
        url: domain + 'doutor/'
      }, del: {
        type: 'delete',
        url: domain + 'doutor/'
      },
      historic: {
        type: 'get',
        url: domain + 'doutor/?/historico'
      },
      files: {
        type: 'post',
        url: domain + 'arquivo/lista'
      },
      associate: domain + 'job/?/evento/associa_doutor'
    },
    flags: {
      list: {
        url: domain + 'flag/lista',
        type: "post"
      },
      create: {
        url: domain + 'flag',
        type: "post"
      },
      update: {
        url: domain + 'flag/',
        type: "put"
      },
      del: {
        url: domain + 'flag/',
        type: "delete"
      }
    },
    basecost: {
      list: {
        url: domain + 'base_custo/lista',
        type: "post"
      },
      create: {
        url: domain + 'base_custo',
        type: "post"
      },
      get: {
        url: domain + 'base_custo/',
        type: "get"
      },
      update: {
        url: domain + 'base_custo/',
        type: "put"
      },
      del: {
        url: domain + 'base_custo/',
        type: "delete"
      }

    },
    report: {
      analiseReceita: domain + 'relatorio/financeiro/analise_receita',
      extractSupporter:
      {
        url: domain + 'relatorio/financeiro/extrato/doutor',
        type: 'post'
      },
      contaazul:
      {
        url: domain + 'relatorio/financeiro/extrato/conta_azul',
        type: 'post'
      },
      cashflow: {
        chart:
        {
          url: domain + 'relatorio/financeiro/fluxo_caixa',
          type: 'post'
        },
        entry:
        {
          list:
          {
            url: domain + 'relatorio/financeiro/fluxo_caixa/lancamento/lista',
            type: 'post'
          },
          new:
          {
            url: domain + 'relatorio/financeiro/fluxo_caixa/lancamento',
            type: 'post'
          },
          update:
          {
            url: domain + 'relatorio/financeiro/fluxo_caixa/lancamento/',
            type: 'put'
          },
          get:
          {
            url: domain + 'relatorio/financeiro/fluxo_caixa/lancamento/',
            type: 'get'
          },
          del:
          {
            url: domain + 'relatorio/financeiro/fluxo_caixa/lancamento/',
            type: 'delete'
          }
        }

      },
    },
    orientation: {
      supporter: {
        get: {
          url: domain + 'orientacao_padrao',
          type: 'get'
        },
        update: {
          url: domain + 'orientacao_padrao',
          type: 'put'
        }
      }
    },
    payment: {
      pagamento: domain + 'financeiro/importacao/retorno/pagamento',
      faturamento: domain + 'financeiro/importacao/retorno/faturamento',
      cicle: {
        url: domain + 'relatorio/financeiro/extrato/pagamento_ciclo?',
        type: 'get'
      },
      cnab: {
        url: domain + 'relatorio/financeiro/extrato/pagamento_ciclo_cnab240?',
        type: 'get'
      },
    },
    guidelines: {
      base: domain + 'orientacao/',
      new: {
        type: 'post',
        url: domain + 'orientacao',
      },
      list: {
        type: 'post',
        url: domain + 'orientacao/lista',
      }
    },
    bank: {
      base: domain + 'banco/',
      new: {
        type: 'post',
        url: domain + 'banco',
      },
      list: {
        type: 'post',
        url: domain + 'banco/lista',
      }
    },
    basisCost: {
      type: 'post',
      url: domain + 'base_custo/lista',
    },
    speciality: {
      type: 'post',
      url: domain + 'especialidade/lista',
    },
    especialidade: {
      post: domain + "especialidade",
      del: domain + "especialidade/",
      put: domain + "especialidade/",
    },
    area: {
      list: domain + "area/lista",
      post: domain + "area",
      put: domain + "area/",
      del: domain + "area/",
    },
    competencia: {
      list: domain + "competencia/lista",
      post: domain + "competencia",
      put: domain + "competencia/",
      del: domain + "competencia/",
    },
    servicestype: {
      costProportion: domain + "/tipo_servico/proporcao_custo_orcado",
      list: {
        type: 'post',
        url: domain + 'tipo_servico/lista',
      },
      base: domain + 'tipo_servico/',
      new: domain + 'tipo_servico',
    },
    pendencies: {
      new: domain + 'pendencia',
      list: domain + 'pendencia/lista',
      update: domain + 'pendencia/',
      del: domain + 'pendencia/',
    },
    menu: {
      menu: domain + 'menu',
      post: domain + 'funcionalidade',
      get: domain + 'funcionalidade/lista',
      delete: domain + 'funcionalidade/',
      put: domain + 'funcionalidade/'
    },
    group: {
      new: domain + 'grupo',
      list: domain + 'grupo/lista',
      put: domain + 'grupo/',
      delete: domain + 'grupo/',
      permissions: {
        list: domain + 'permissao_grupo/lista',
        put: domain + 'permissao_grupo',
        del: domain + 'permissao_grupo/'
      }
    },
    partners: {
      enable: domain + 'parceiro/doutor/lista',
      post: domain + 'parceiro/lista',
      get: domain + 'parceiro/?/cidade/?',
      supporter: domain + 'parceiro/doutor/?/cidade/?',
      city: { // PUT
        associate: domain + 'parceiro/associa/?/cidade/?',
        disassociate: domain + 'parceiro/desassocia/?/cidade/?'
      },
      client: { // PUT                
        associate: domain + 'parceiro/associa/?/cidade/?/cliente/?',
        disassociate: domain + 'parceiro/desassocia/?/cidade/?/cliente/?',
      }
    },
    clients: {
      list: domain + 'cliente/lista',
      put: domain + 'cliente/',
      usuario: domain + 'cliente/?/usuario',
      operacao: domain + 'cliente/?/operacao',
      cities: domain + 'cidade_cliente'
    },
    clients_aggregate: domain + 'agregado_cliente',
    clients_aggregate_del: domain + 'agregado_cliente/?/status',
    clients_aggregate_activate: domain + 'agregado_cliente/?/status',
    clients_aggregate_list: domain + 'agregado_cliente/lista',
    clients_aggregate_import: domain + 'agregado_cliente/?/arquivo',
    supporter_aggregate: domain + 'agregado_doutor',
    supporter_aggregate_activate: domain + 'agregado_doutor/?/status',
    communication: {
      create: domain + 'comunicado',
      get: domain + 'comunicado/lista',
      publish: domain + 'comunicado_usuario',
      canais: domain + 'comunicacao_massiva/canais',
      supporter: {
        list: domain + 'comunicacao_massiva/lista',
        create: domain + 'comunicacao_massiva',
        delete: domain + 'comunicacao_massiva/'
      },
      create_supporter: domain + "comunicacao_massiva",
      stats: domain + "comunicacao_massiva/estatisticas"
    },
    sla: domain + 'job/conta',
    take: domain + 'job/?/gestor/',
    template: {
      create: domain + 'comunicado/arquivo',
      update: domain + 'comunicado/?/arquivo'
    },
    nf: domain + 'nota_fiscal/doutor/lista',
    nf_file: domain + 'nota_fiscal/doutor/arquivo/',
    nf_validate: domain + 'nota_fiscal/doutor/?/',
    negocios: domain + 'negocio/lista/ganho',

  },
  certificater: {
    list: domain + 'certificadora/lista_certificados',
    lists: domain + 'certificadora/lista',
    get: domain + 'certificadora/?',
    post: domain + 'certificadora',
    delete: domain + 'certificadora/?',
    put: domain + 'certificadora/?'

  },
  certificate: {
    list: domain + 'certificado/lista',
    get: domain + 'certificado/?',
    post: domain + 'certificado',
    delete: domain + 'certificado/?',
    put: domain + 'certificado/?',
    supporter: domain + 'doutor/certificado'

  },
  tooltype: {
    list: domain + 'tipo_ferramenta/lista_ferramentas',
    lists: domain + 'tipo_ferramenta/lista',
    get: domain + 'tipo_ferramenta/?',
    post: domain + 'tipo_ferramenta',
    delete: domain + 'tipo_ferramenta/?',
    put: domain + 'tipo_ferramenta/?',

  },
  tool: {
    list: domain + 'ferramenta/lista',
    get: domain + 'ferramenta/?',
    post: domain + 'ferramenta',
    delete: domain + 'ferramenta/?',
    put: domain + 'ferramenta/?',
    supporter: domain + 'doutor/ferramenta'
  },

}

export default api